<template>
  <div class="group">
    <div class="groupitem"
        v-for="(item, index) in groups"
        v-bind:class="{ islastitem: Number(index) < (groups.length-1)}"

        :key="item.groupId || ''"
        @click.prevent="chooseGroup(item)">
        {{item.groupName}}
    </div>
  </div>
</template>
<script>
import {mapMutations} from 'vuex'
export default {
  name: 'HeaderGroup',
  props: ['groups'],
  methods: {
    ...mapMutations('header', ['SET_GROUP']),
    chooseGroup (item) {
      this.SET_GROUP({...item})
    }
  }
}
</script>
<style lang="stylus"  scoped >
    .group
        max-height: 195px;
        padding-left: 30px;
        padding-right: 30px;
        overflow-y: auto;
        text-align: center;
        margin: -12px -12px -12px -12px;
    .groupitem:hover
        color: #3467fe
        cursor:pointer
    .groupitem
        height: 65px;
        line-height: 65px;
        font-size: 14px;
        text-overflow: ellipsis;
    .islastitem
        border-bottom: solid 1px #ccc;

</style>
